<div class="features d-flex justify-content-center align-items-center px-4 px-xxl-5">
  <section class="row text-center content-page flex-column flex-md-row">
    <div class="col-md-6 col-lg-3 mb-4 px-0">
      <h2 #counter class="stat-number fw-bold" data-target="50" data-suffix="+">0</h2>
      <p class="stat-text">
        <span class="bullet">●</span> Años de experiencia combinada en el sector financiero
      </p>
    </div>
    <div class="col-md-6 col-lg-3 mb-4 px-0">
      <h2 #counter class="stat-number fw-bold" data-target="20" data-suffix="+">0</h2>
      <p class="stat-text">
        <span class="bullet">●</span> Instituciones aliadas bajo regulación de primer nivel
      </p>
    </div>
    <div class="col-md-6 col-lg-3 mb-4 px-0">
      <h2 #counter class="stat-number fw-bold" data-target="95" data-suffix="%+">0</h2>
      <p class="stat-text">
        <span class="bullet">●</span> Fidelización de clientes en mercados internacionales
      </p>
    </div>
    <div class="col-md-6 col-lg-3 mb-4 px-0">
      <h2 #counter class="stat-number fw-bold" data-target="10" data-prefix="<" data-suffix="%">0</h2>
      <p class="stat-text">
        <span class="bullet">●</span> De instituciones financieras superan nuestro estricto due diligence
      </p>
    </div>
  </section>
</div>
